const papersDataCambridgeIgcse = {
  mathematics: [
    {
      year: '2025 (Specimen)',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/663662-2025-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/663670-2025-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/663664-2025-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/663672-2025-specimen-paper-2-mark-scheme.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/663666-2025-specimen-paper-3.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/663674-2025-specimen-paper-3-mark-scheme.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/663668-2025-specimen-paper-4.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/663676-2025-specimen-paper-4-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_ms_12.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_ms_22.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_qp_32.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_ms_32.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2024-March/0580_m24_ms_42.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/569923-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/569919-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/569924-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/569920-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/569925-june-2023-question-paper-31.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/569921-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/671439-june-2023-question-paper-41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671437-june-2023-mark-scheme-paper-41.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2022-May-June/0580_s22_ms_41.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-Oct-Nov/0580_w21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-0580/2021-May-June/0580_s21_ms_41.pdf',
        },
      ],
    },
    {
      year: '2020 (Specimen)',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/415732-2020-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/415728-2020-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/415739-2020-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-mathematics-0580/past-papers/',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-mathematics-0580/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/Images/415742-2020-specimen-paper-3-mark-scheme.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-mathematics-0580/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/Images/415746-2020-specimen-paper-4-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0580_s19_ms_41.pdf',
        },
      ],
    },
  ],
  biology: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_12.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_22.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_32.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_32.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_42.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_52.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_52.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_qp_62.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2024-March/0610_m24_ms_62.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/520441-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-biology-0610/past-papers/',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/520442-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/520430-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-biology-0610/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/Images/520431-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-biology-0610/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/Images/649816-june-2023-mark-scheme-paper-41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cambridgeinternational.org/Images/649823-june-2023-question-paper-51.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/649817-june-2023-mark-scheme-paper-51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-biology-0610/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/Images/649818-june-2023-mark-scheme-paper-61.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2022-May-June/0610_s22_qp_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2021-May-June/0610_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Biology-0610/2020-May-June/0610_s20_ms_61.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0610_s19_ms_61.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_ms_61.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0610_s18_ms_61.pdf',
        },
      ],
    },
  ],
  chemistry: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2024-May-June/0620_s24_ms_61.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cambridgeinternational.org/Images/520441-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-chemistry-0620/past-papers/',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cambridgeinternational.org/Images/520512-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-chemistry-0620/past-papers/',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-chemistry-0620/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-chemistry-0620/past-papers/',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-chemistry-0620/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/Images/671413-june-2023-mark-scheme-paper-41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cambridgeinternational.org/Images/671420-june-2023-question-paper-51.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671414-june-2023-mark-scheme-paper-51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cambridgeinternational.org/Images/671421-june-2023-question-paper-61.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671415-june-2023-mark-scheme-paper-61.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2022-May-June/0620_s22_ms_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2021-May-June/0620_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Chemistry-0620/2020-May-June/0620_s20_ms_61.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0620_s19_ms_61.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0620_s18_ms_61.pdf',
        },
      ],
    },
  ],
  physics: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3 (Core)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4 (Extended)',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2024-May-June/0625_s24_ms_61.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-physics-0625/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/Images/570004-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-physics-0625/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-physics-0625/past-papers/',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-physics-0625/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/Images/570006-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-physics-0625/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/Images/671373-june-2023-mark-scheme-paper-41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cambridgeinternational.org/Images/671386-june-2023-question-paper-51.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671374-june-2023-mark-scheme-paper-51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-physics-0625/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/Images/671375-june-2023-mark-scheme-paper-61.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2022-May-June/0625_s22_ms_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2021-May-June/0625_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_ms_12.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_ms_22.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_qp_32.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_ms_32.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_ms_42.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_qp_52.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_ms_52.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_qp_62.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Physics-0625/2020-March/0625_m20_ms_62.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0625_s19_ms_61.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link: 'https://www.cienotes.com/igcse-physics-2018-past-papers/',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_ms_41.pdf',
        },
        {
          label: 'Practical Test',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_ms_51.pdf',
        },
        {
          label: 'Alternative to Practical',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/09/0625_s18_ms_61.pdf',
        },
      ],
    },
  ],
  coordinatedscience: [
    {
      year: '2025 (Specimen Paper)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/671101-2025-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671110-2025-specimen-mark-scheme-paper-1.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/671102-2025-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671111-2025-specimen-mark-scheme-paper-2-.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://www.cambridgeinternational.org/Images/671103-2025-specimen-paper-3.pdf',
          marking:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-sciences-co-ordinated-double-0654/past-papers/',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/671242-2025-specimen-paper-4.pdf',
          marking:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-sciences-co-ordinated-double-0654/past-papers/',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-sciences-co-ordinated-double-0654/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/Images/671406-2025-specimen-mark-scheme-5.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://www.cambridgeinternational.org/Images/671402-2025-specimen-paper-6.pdf',
          marking:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-sciences-co-ordinated-double-0654/past-papers/',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2024-May-June/0654_s24_ms_61.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/570109-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/570103-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/570111-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-sciences-co-ordinated-double-0654/past-papers/',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://www.cambridgeinternational.org/Images/570110-june-2023-question-paper-31.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/570104-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/671320-june-2023-question-paper-41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671314-june-2023-mark-scheme-paper-41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cambridgeinternational.org/Images/671321-june-2023-question-paper-51.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671315-june-2023-mark-scheme-paper-51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://www.cambridgeinternational.org/Images/671322-june-2023-question-paper-61.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/671316-june-2023-mark-scheme-paper-61.pdf',
        },
      ],
    },
    {
      year: '2022 (Added)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2022-May-June/0654_s22_ms_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2021-May-June/0654_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Sciences-Co-ordinated-Double-0654/2020-May-June/0654_s20_ms_61.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/0654_s19_ms_61.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_1_1_qp.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_1_1_ms.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_2_1_qp.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_2_1_ms.pdf',
        },
        {
          label: 'Paper 3 ',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_3_1_qp.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_3_1_ms.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_4_1_qp.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_4_1_ms.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_5_1_qp.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_5_1_ms.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_6_1_qp.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0654_s18_6_1_ms.pdf',
        },
      ],
    },
  ],
  economics: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2024-May-June/0455_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2024-May-June/0455_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2024-May-June/0455_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2024-May-June/0455_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/521309-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/521303-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/521311-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/521307-june-2023-mark-scheme-paper-21.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2022-May-June/0455_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2022-May-June/0455_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2022-May-June/0455_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2022-May-June/0455_s22_ms_22.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2021-May-June/0455_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2021-May-June/0455_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2021-May-June/0455_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Economics-0455/2021-May-June/0455_s21_ms_22.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/414644-2020-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414652-2020-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/414646-2020-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414654-2020-specimen-paper-2-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0455_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0455_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0455_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0455_s19_ms_21.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0455_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0455_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0455_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0455_s18_ms_21.pdf',
        },
      ],
    },
  ],
  businessstudies: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2024-May-June/0450_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2024-May-June/0450_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2024-May-June/0450_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2024-May-June/0450_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/520483-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/520478-june-2023-paper-11-mark-scheme.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/520484-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/520480-june-2023-paper-21-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2022-May-June/0450_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2022-May-June/0450_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2022-May-June/0450_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2022-May-June/0450_s22_ms_21.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2021-May-June/0450_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2021-May-June/0450_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2021-May-June/0450_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Business-Studies-0450/2021-May-June/0450_s21_ms_21.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/414604-2020-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414610-2020-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/414605-2020-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414611-2020-specimen-paper-2-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0450_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0450_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0450_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0450_s19_ms_21.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0450_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0450_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0450_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0450_s18_ms_21.pdf',
        },
      ],
    },
  ],
  englishlanguage: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2024-May-June/0500_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2024-May-June/0500_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2024-May-June/0500_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2024-May-June/0500_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/521350-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/521328-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/521351-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/521329-june-2023-mark-scheme-paper-21.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2022-May-June/0500_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2022-May-June/0500_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2022-May-June/0500_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2022-May-June/0500_s22_ms_21.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2021-May-June/0500_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2021-May-June/0500_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2021-May-June/0500_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-First-Language-0500/2021-May-June/0500_s21_ms_21.pdf',
        },
      ],
    },
    {
      year: '2020 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/414814-2020-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414810-2020-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/414816-2020-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414811-2020-specimen-paper-2-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0500_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0500_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0500_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0500_s19_ms_21.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0500_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0500_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0500_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0500_s18_ms_21.pdf',
        },
      ],
    },
  ],
  englishliterature: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2024-May-June/0475_s24_ms_41.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/646856-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/646850-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/646858-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/646851-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cambridgeinternational.org/Images/646861-june-2023-question-paper-31.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/646853-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/670222-june-2023-question-paper-41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/670220-june-2023-mark-scheme-paper-41.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2022-May-June/0475_s22_ms_41.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/English-Literature-0475/2021-May-June/0475_s21_ms_41.pdf',
        },
      ],
    },
    {
      year: '2020 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/414753-2020-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414779-2020-specimen-mark-scheme-1.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/414755-2020-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414780-2020-specimen-paper-2-mark-scheme.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cambridgeinternational.org/Images/414758-2020-specimen-paper-3.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414783-2020-specimen-paper-3-mark-scheme.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/414759-2020-specimen-paper-4.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/414784-2020-specimen-paper-4-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0486_s19_ms_41.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/07/0486_s18_ms_41.pdf',
        },
      ],
    },
  ],
  additionalmathematics: [
    {
      year: '2025 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/664576-2025-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/664580-specimen-paper-1-markscheme.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-mathematics-additional-0606/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/Images/664581-2025-specimen-paper-2-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2024-May-June/0606_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2024-May-June/0606_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2024-May-June/0606_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2024-May-June/0606_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/647366-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/647358-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/647367-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/647359-june-2023-mark-scheme-paper-21.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2022-May-June/0606_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2022-May-June/0606_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2022-May-June/0606_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2022-May-June/0606_s22_ms_21.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2021-May-June/0606_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2021-May-June/0606_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2021-May-June/0606_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Mathematics-Additional-0606/2021-May-June/0606_s21_ms_21.pdf',
        },
      ],
    },
    {
      year: '2020 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-mathematics-additional-0606/past-papers/',
          marking:
            'https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-igcse-mathematics-additional-0606/past-papers/',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/415797-2020-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/415794-2020-specimen-paper-2-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0606_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0606_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0606_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/07/0606_s19_ms_21.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/08/0606_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/08/0606_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/08/0606_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/08/0606_s18_ms_21.pdf',
        },
      ],
    },
  ],
  computerscience: [
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2024-May-June/0478_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2024-May-June/0478_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2024-May-June/0478_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2024-May-June/0478_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/520650-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/520648-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/520651-june-2022-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/520655-june-2023-mark-scheme-paper-21.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2022-May-June/0478_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2022-May-June/0478_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2022-May-June/0478_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2022-May-June/0478_s22_ms_21.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2021-May-June/0478_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2021-May-June/0478_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2021-May-June/0478_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2021-May-June/0478_s21_ms_21.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2020-May-June/0478_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2020-May-June/0478_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2020-May-June/0478_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/IGCSE/Computer-Science-0478/2020-May-June/0478_s20_ms_21.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0478_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0478_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0478_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/06/0478_s19_ms_21.pdf',
        },
      ],
    },
    {
      year: '2018',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0478_s18_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0478_s18_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0478_s18_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2018/10/0478_s18_ms_21.pdf',
        },
      ],
    },
  ],
  environmentalmanagement: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s25_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s25_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s25_ms_21.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s24_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s24_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s24_ms_21.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://www.cambridgeinternational.org/Images/523457-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/523449-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://www.cambridgeinternational.org/Images/523460-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/523450-june-2023-mark-scheme-paper-21.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s22_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s22_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0680_s22_ms_21.pdf',
        },
      ],
    },
  ],
  french: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s25_ms_41.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s24_ms_41.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://www.cambridgeinternational.org/Images/569567-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/569562-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://www.cambridgeinternational.org/Images/569568-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/569563-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://www.cambridgeinternational.org/Images/569571-june-2023-role-play-paper-03.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/569572-june-2023-teachers-notes-paper-03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://www.cambridgeinternational.org/Images/569569-june-2023-question-paper-41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/569564-june-2023-mark-scheme-paper-41.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0520_s22_ms_41.pdf',
        },
      ],
    },
  ],
  german: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s25_ms_41.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s24_ms_41.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://www.cambridgeinternational.org/Images/569629-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/569627-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://www.cambridgeinternational.org/Images/670389-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/670385-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://www.cambridgeinternational.org/Images/569633-june-2023-role-play-paper-03.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/569634-june-2023-teachers-notes-paper-03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://www.cambridgeinternational.org/Images/670390-june-2023-question-paper-41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/670386-june-2023-mark-scheme-paper-41.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0525_s22_ms_41.pdf',
        },
      ],
    },
  ],
  spanish: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s25_ms_41.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s24_ms_41.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://www.cambridgeinternational.org/Images/570167-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/570164-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://www.cambridgeinternational.org/Images/570168-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/570165-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://www.cambridgeinternational.org/Images/570170-june-2023-role-play-paper-03.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/570171-june-2023-teachers-notes-paper-03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://www.cambridgeinternational.org/Images/570169-june-2023-question-paper-41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/570166-june-2023-mark-scheme-paper-41.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_rp_03.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_tn_03.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0530_s22_ms_41.pdf',
        },
      ],
    },
  ],
  statistics: [
    {
      year: '2027 (Specimen)',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://www.cambridgeinternational.org/Images/718826-2027-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/718830-2027-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://www.cambridgeinternational.org/Images/718827-2027-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/718831-2027-specimen-paper-2-mark-scheme.pdf',
        },
      ],
    },
  ],
  globalperspectives: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0457_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0457_s25_ms_11.pdf',
        },
        {
          label: 'Insert 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0457_s25_in_11.pdf',
          marking: '',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0457_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0457_s24_ms_11.pdf',
        },
        {
          label: 'Insert 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0457_s24_in_11.pdf',
          marking: '',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://www.cambridgeinternational.org/Images/569655-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/569654-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Insert 01',
          link:
            'https://www.cambridgeinternational.org/Images/569653-june-2023-paper-11-insert.pdf',
          marking: '',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0457_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0457_s22_ms_11.pdf',
        },
        {
          label: 'Insert 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/0457_s22_in_11.pdf',
          marking: '',
        },
      ],
    },
  ],
};

export default papersDataCambridgeIgcse;
